var map = {
	"./amazon-com-proxy-voting-information.jpg": 2136,
	"./campbell-soup-proxy-voting-information.jpg": 2137,
	"./comcast-proxy-voting-information.jpg": 2138,
	"./microsoft-proxy-voting-information.jpg": 2139
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2135;